module.exports = __webpack_public_path__ + "assets/img/1f85-ve.svg";